import { __read, __spreadArray } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import { useHotkeys as se } from './../../external_lib/react-hotkeys-hook/packages/react-hotkeys-hook/dist/index.js';
import classNames from './../../external_lib/classnames/index.js';
import HorizonTooltip from '../../base/HorizonTooltip/index.js';
import Accordian, { AccordionGroup } from '../../helpers/accordion/index.js';
import Popover from '../../helpers/popover/index.js';
import ChevronDown from '../../assets/icons/jsx/ChevronDown.js';
import Lock from '../../assets/icons/jsx/Lock.js';
import DoubleChevronLeft from '../../assets/icons/jsx/DoubleChevronLeft.js';
import HorizonText, { TextVariant } from '../../base/HorizonText/index.js';
import HorizonChip from '../../base/HorizonChip/index.js';
import styles from '../../components/sublayouts/SideNav/index.module.scss.js';
import CssVariables from '../../theme/variables/CssVariables.js';
import { getSideNavFilledIcon, getSideNavOutlineIcon } from '../../helpers/sideNavIcons/index.js';
import { RouterWrapper, CustomLink } from '../../helpers/router/index.js';
import { isMacOS, getKeyForOS } from '../../utils/os.util.js';
import { getActiveAppPath } from '../../utils/string.util.js';
function SideNav(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    header = _a.header,
    footer = _a.footer,
    customBody = _a.customBody,
    sideNavItems = _a.sideNavItems,
    activeKey = _a.activeKey,
    collapsed = _a.collapsed,
    onSideNavItemClick = _a.onSideNavItemClick,
    _c = _a.v2,
    v2 = _c === void 0 ? false : _c,
    toggleCollapsed = _a.toggleCollapsed,
    routerProps = _a.routerProps;
  var _d = __read(useState(''), 2),
    accordionClicked = _d[0],
    setAccordionClicked = _d[1];
  var handleSideNavItemClick = function (key) {
    // to persist the selected child if the parent collapses
    if ((key === null || key === void 0 ? void 0 : key.length) < 2 && (key === null || key === void 0 ? void 0 : key[0]) === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0])) {
      return;
    }
    onSideNavItemClick === null || onSideNavItemClick === void 0 ? void 0 : onSideNavItemClick(key);
  };
  var handleAccordionClicked = function (key) {
    if (accordionClicked === key) {
      setAccordionClicked('');
      return;
    }
    setAccordionClicked(key);
  };
  se(isMacOS() ? 'meta+slash' : 'mod+slash', function () {
    if (toggleCollapsed) {
      toggleCollapsed();
    }
  });
  if (v2) {
    return React__default.createElement(RouterWrapper, {
      routerProps: routerProps
    }, React__default.createElement(SideNavContentV2, {
      className: className,
      header: header,
      footer: footer,
      customBody: customBody,
      sideNavItems: sideNavItems,
      activeKey: activeKey,
      collapsed: collapsed,
      handleSideNavItemClick: handleSideNavItemClick,
      handleAccordionClicked: handleAccordionClicked,
      accordionClicked: accordionClicked,
      toggleCollapsed: toggleCollapsed
    }));
  }
  return React__default.createElement(RouterWrapper, {
    routerProps: routerProps
  }, React__default.createElement(SideNavContent, {
    className: className,
    header: header,
    footer: footer,
    customBody: customBody,
    sideNavItems: sideNavItems,
    activeKey: activeKey,
    collapsed: collapsed,
    handleSideNavItemClick: handleSideNavItemClick,
    handleAccordionClicked: handleAccordionClicked,
    accordionClicked: accordionClicked
  }));
}
var SideNavContent = function (_a) {
  var _b;
  var _c = _a.className,
    className = _c === void 0 ? '' : _c,
    header = _a.header,
    footer = _a.footer,
    customBody = _a.customBody,
    sideNavItems = _a.sideNavItems,
    activeKey = _a.activeKey,
    collapsed = _a.collapsed,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    handleAccordionClicked = _a.handleAccordionClicked,
    _d = _a.accordionClicked,
    accordionClicked = _d === void 0 ? '' : _d;
  return React__default.createElement("div", {
    className: classNames(className, styles.sideNavContent, (_b = {}, _b[styles.sideNavCollapsed] = collapsed, _b))
  }, header ? React__default.createElement("div", {
    className: styles.sideNavHeader
  }, header) : null, customBody ? React__default.createElement("div", {
    className: styles.sideNavCustomBody
  }, customBody) : null, React__default.createElement("div", {
    className: styles.sideNavBody
  }, React__default.createElement(AccordionGroup, {
    type: "single",
    collapsible: true,
    defaultValue: activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]
  }, sideNavItems === null || sideNavItems === void 0 ? void 0 : sideNavItems.map(function (item) {
    var _a;
    return React__default.createElement(Accordian, {
      disabled: item === null || item === void 0 ? void 0 : item.disabled,
      value: item.key,
      className: styles.sideNavAccordian,
      key: item.key,
      header: !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length) && getActiveAppPath(item) ? React__default.createElement(CustomLink, {
        to: getActiveAppPath(item)
      }, React__default.createElement(SideNavItemHeader, {
        item: item,
        handleSideNavItemClick: function (key) {
          var _a;
          if (collapsed || !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
            handleSideNavItemClick(key);
          }
        },
        handleAccordionClicked: handleAccordionClicked,
        accordionClicked: accordionClicked,
        activeKey: activeKey,
        collapsed: collapsed
      })) : React__default.createElement(SideNavItemHeader, {
        item: item,
        handleSideNavItemClick: function (key) {
          var _a;
          if (collapsed || !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
            handleSideNavItemClick(key);
          }
        },
        handleAccordionClicked: handleAccordionClicked,
        accordionClicked: accordionClicked,
        activeKey: activeKey,
        collapsed: collapsed
      }),
      content: !collapsed && item.childrenProps ? React__default.createElement(SideNavItemContent, {
        item: item,
        handleSideNavItemClick: handleSideNavItemClick,
        activeKey: activeKey,
        collapsed: collapsed
      }) : null
    });
  }))), footer ? React__default.createElement("div", {
    className: styles.sideNavFooter
  }, footer) : null);
};
var SideNavContentV2 = function (_a) {
  var _b;
  var _c;
  var _d = _a.className,
    className = _d === void 0 ? '' : _d,
    header = _a.header,
    footer = _a.footer,
    customBody = _a.customBody,
    sideNavItems = _a.sideNavItems,
    activeKey = _a.activeKey,
    collapsed = _a.collapsed,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    handleAccordionClicked = _a.handleAccordionClicked,
    _e = _a.accordionClicked,
    accordionClicked = _e === void 0 ? '' : _e,
    toggleCollapsed = _a.toggleCollapsed;
  var getActiveNavItem = function () {
    if (activeKey && (activeKey === null || activeKey === void 0 ? void 0 : activeKey.length) > 0) {
      return sideNavItems === null || sideNavItems === void 0 ? void 0 : sideNavItems.find(function (item) {
        return item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]);
      });
    }
    return null;
  };
  var activeNavItem = useMemo(function () {
    return getActiveNavItem();
  }, [activeKey]);
  useEffect(function () {
    var _a, _b;
    if (!collapsed && !((_a = activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.childrenProps) === null || _a === void 0 ? void 0 : _a.length) && toggleCollapsed) {
      toggleCollapsed();
    } else if (collapsed && ((_b = activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.childrenProps) === null || _b === void 0 ? void 0 : _b.length) && toggleCollapsed) {
      toggleCollapsed();
    }
  }, [activeNavItem]);
  useEffect(function () {
    if (!collapsed && !activeNavItem && toggleCollapsed) {
      toggleCollapsed();
    }
  }, [collapsed]);
  return React__default.createElement("div", {
    className: classNames(className, styles.sideNavContent, styles.v2, (_b = {}, _b[styles.sideNavCollapsed] = collapsed, _b))
  }, header ? React__default.createElement("div", {
    className: styles.sideNavHeader
  }, header) : null, customBody ? React__default.createElement("div", {
    className: styles.sideNavCustomBody
  }, customBody) : null, activeNavItem && React__default.createElement("div", {
    className: styles.sideNavBody
  }, React__default.createElement("div", {
    className: classNames('pt-[18px] pb-3 px-4 flex items-center justify-between gap-1 overflow-hidden border-0 border-b border-solid border-b-up-black-10 bg-up-black-5 sticky z-10', styles.activeNavItemLabel)
  }, React__default.createElement(HorizonText, {
    className: "font-semibold truncate",
    variant: TextVariant.HEADING5,
    inline: true
  }, activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.label), React__default.createElement(HorizonTooltip, {
    trigger: ['hover'],
    title: React__default.createElement(HorizonText, {
      className: "text-up-black-80 p-1 flex flex-col",
      variant: TextVariant.BODY2_SEMIBOLD
    }, "Collapse panel", getKeyForOS() && React__default.createElement(HorizonText, {
      variant: TextVariant.BODY2,
      className: "text-up-black-50",
      inline: true
    }, getKeyForOS(), " /")),
    placement: "bottom",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0
  }, React__default.createElement(DoubleChevronLeft, {
    className: "text-up-black-60 p-2 hover:bg-up-black-10 rounded cursor-pointer !box-content",
    onClick: toggleCollapsed
  }))), (activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.description) && React__default.createElement("div", {
    className: classNames('py-2 px-4 h-max max-h-[78px] border-0 border-b border-solid border-b-up-black-10 bg-up-black-5 sticky z-10', styles.activeNavItemDescription)
  }, React__default.createElement(HorizonText, {
    className: "text-up-black-60 line-clamp-3",
    variant: TextVariant.BODY2,
    inline: true
  }, activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.description)), React__default.createElement(AccordionGroup, {
    type: "single",
    collapsible: true,
    defaultValue: activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]
  }, (_c = activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.childrenProps) === null || _c === void 0 ? void 0 : _c.map(function (item) {
    var _a;
    return React__default.createElement(Accordian, {
      disabled: item === null || item === void 0 ? void 0 : item.disabled,
      value: item.key,
      className: styles.sideNavAccordian,
      key: item.key,
      header: !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length) && getActiveAppPath(item) ? React__default.createElement(CustomLink, {
        to: getActiveAppPath(item)
      }, React__default.createElement(SideNavItemHeaderV2, {
        item: item,
        handleSideNavItemClick: function (key) {
          var _a;
          if (collapsed || !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
            handleSideNavItemClick(__spreadArray([activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.key], __read(key), false));
          }
        },
        handleAccordionClicked: handleAccordionClicked,
        accordionClicked: accordionClicked,
        activeKey: activeKey,
        collapsed: collapsed
      })) : React__default.createElement(SideNavItemHeaderV2, {
        item: item,
        handleSideNavItemClick: function (key) {
          var _a;
          if (collapsed || !((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
            handleSideNavItemClick(__spreadArray([activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.key], __read(key), false));
          }
        },
        handleAccordionClicked: handleAccordionClicked,
        accordionClicked: accordionClicked,
        activeKey: activeKey,
        collapsed: collapsed
      }),
      content: item.childrenProps ? React__default.createElement(SideNavItemContentV2, {
        item: item,
        handleSideNavItemClick: function (key) {
          return handleSideNavItemClick(__spreadArray([activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.key], __read(key), false));
        },
        activeKey: activeKey,
        collapsed: collapsed
      }) : null
    });
  }))), footer ? React__default.createElement("div", {
    className: styles.sideNavFooter
  }, footer) : null);
};
var SideNavItemHeader = function (_a) {
  var _b;
  var _c, _d;
  var item = _a.item,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    handleAccordionClicked = _a.handleAccordionClicked,
    accordionClicked = _a.accordionClicked,
    _e = _a.activeKey,
    activeKey = _e === void 0 ? [] : _e,
    collapsed = _a.collapsed;
  return React__default.createElement("div", {
    "data-state": "".concat(item.key),
    onClick: function () {
      var _a, _b;
      if (collapsed && ((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
      }
      handleAccordionClicked(((_b = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _b === void 0 ? void 0 : _b.length) ? item.key : '');
      return !(item === null || item === void 0 ? void 0 : item.disabled) && (handleSideNavItemClick === null || handleSideNavItemClick === void 0 ? void 0 : handleSideNavItemClick([item.key]));
    },
    className: classNames(styles.sideNavItemHeader, (_b = {}, _b[styles.sideNavItemHeaderActive] = item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]), _b[styles.sideNavItemOpen] = !collapsed && accordionClicked === item.key, _b[styles.sideNavItemHeaderActiveWithChildren] = !collapsed && item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]) && ((_c = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _c === void 0 ? void 0 : _c.find(function (child) {
      return (child === null || child === void 0 ? void 0 : child.key) === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[1]);
    })) && ((_d = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _d === void 0 ? void 0 : _d.length), _b[styles.sideNavItemHeaderCollapsed] = collapsed, _b[styles.sideNavItemHeaderDisabled] = item === null || item === void 0 ? void 0 : item.disabled, _b))
  }, collapsed ? React__default.createElement(Popover, {
    contentWidth: "auto",
    contentSide: "right",
    closeOnContentClick: true,
    popoverContentProps: {
      alignOffset: -8,
      sideOffset: 12,
      arrowPadding: 42
    },
    content: React__default.createElement(SideNavItemContent, {
      item: item,
      activeKey: activeKey,
      collapsed: collapsed,
      handleSideNavItemClick: handleSideNavItemClick
    })
  }, item.iconId ? React__default.createElement("div", {
    className: styles.collapsedSideNavItemIcon
  }, item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]) ? getSideNavFilledIcon(item.iconId, {
    className: styles.sideNavItemIcon
  }) : getSideNavOutlineIcon(item.iconId, {
    className: styles.sideNavItemIcon
  })) : item.icon ? React__default.createElement("div", {
    className: styles.customSideNavItemIcon
  }, React__default.createElement("img", {
    src: item.icon,
    alt: ""
  })) : null) : React__default.createElement(React__default.Fragment, null, item.iconId ? React__default.createElement(React__default.Fragment, null, item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]) ? getSideNavFilledIcon(item.iconId, {
    className: styles.sideNavItemIcon
  }) : getSideNavOutlineIcon(item.iconId, {
    className: styles.sideNavItemIcon
  })) : item.icon ? React__default.createElement("div", {
    className: styles.customSideNavItemIcon
  }, React__default.createElement("img", {
    src: item.icon,
    alt: ""
  })) : null), !collapsed && React__default.createElement(React__default.Fragment, null, React__default.createElement(HorizonText, {
    className: styles.sideNavItemLabel
  }, item.label), item.isNew && React__default.createElement(SideNavItemChip, {
    text: "New",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isBeta && React__default.createElement(SideNavItemChip, {
    text: "Beta",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isLocked && React__default.createElement(Lock, {
    className: styles.lockIcon
  }), item.childrenProps ? React__default.createElement(ChevronDown, {
    className: styles.sideNavItemChevron
  }) : null));
};
var SideNavItemHeaderV2 = function (_a) {
  var _b;
  var _c, _d;
  var item = _a.item,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    handleAccordionClicked = _a.handleAccordionClicked,
    accordionClicked = _a.accordionClicked,
    _e = _a.activeKey,
    activeKey = _e === void 0 ? [] : _e,
    collapsed = _a.collapsed;
  return React__default.createElement("div", {
    "data-state": "".concat(item.key),
    onClick: function () {
      var _a, _b;
      if (collapsed && ((_a = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
      }
      handleAccordionClicked(((_b = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _b === void 0 ? void 0 : _b.length) ? item.key : '');
      return !(item === null || item === void 0 ? void 0 : item.disabled) && (handleSideNavItemClick === null || handleSideNavItemClick === void 0 ? void 0 : handleSideNavItemClick([item.key]));
    },
    className: classNames(styles.sideNavItemHeader, (_b = {}, _b[styles.sideNavItemHeaderActive] = item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[1]), _b[styles.sideNavItemOpen] = accordionClicked === item.key, _b[styles.sideNavItemHeaderActiveWithChildren] = !collapsed && item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[1]) && ((_c = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _c === void 0 ? void 0 : _c.find(function (child) {
      return (child === null || child === void 0 ? void 0 : child.key) === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[2]);
    })) && ((_d = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _d === void 0 ? void 0 : _d.length),
    // [styles.sideNavItemHeaderCollapsed]: collapsed,
    _b[styles.sideNavItemHeaderDisabled] = item === null || item === void 0 ? void 0 : item.disabled, _b))
  }, React__default.createElement(HorizonText, {
    className: styles.sideNavItemLabel
  }, item.label), item.isNew && React__default.createElement(SideNavItemChip, {
    text: "New",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isBeta && React__default.createElement(SideNavItemChip, {
    text: "Beta",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isLocked && React__default.createElement(Lock, {
    className: styles.lockIcon
  }), item.childrenProps ? React__default.createElement(ChevronDown, {
    className: styles.sideNavItemChevron
  }) : null);
};
var SideNavItemContent = function (_a) {
  var _b;
  var _c, _d;
  var item = _a.item,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    activeKey = _a.activeKey,
    collapsed = _a.collapsed;
  return React__default.createElement("div", {
    className: classNames(styles.sideNavItemContent, (_b = {}, _b[styles.sideNavItemContentCollapsed] = collapsed, _b[styles.sideNavItemContentWithoutChildren] = !((_c = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _c === void 0 ? void 0 : _c.length), _b))
  }, collapsed && React__default.createElement(HorizonText, {
    className: styles.sideNavSubmenuItemLabel
  }, item.label, item.isNew && React__default.createElement(SideNavItemChip, {
    text: "New",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isBeta && React__default.createElement(SideNavItemChip, {
    text: "Beta",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), item.isLocked && React__default.createElement(Lock, {
    className: styles.lockIcon
  })), (_d = item.childrenProps) === null || _d === void 0 ? void 0 : _d.map(function (child) {
    return getActiveAppPath(child) ? React__default.createElement(CustomLink, {
      key: child.key,
      to: getActiveAppPath(child)
    }, React__default.createElement(NavItemText, {
      item: item,
      child: child,
      handleSideNavItemClick: handleSideNavItemClick,
      activeKey: activeKey
    })) : React__default.createElement(NavItemText, {
      key: child.key,
      item: item,
      child: child,
      handleSideNavItemClick: handleSideNavItemClick,
      activeKey: activeKey
    });
  }));
};
var NavItemText = function (_a) {
  var _b;
  var item = _a.item,
    child = _a.child,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    activeKey = _a.activeKey;
  return React__default.createElement("div", {
    "data-state": "".concat(item.key, "-").concat(child.key),
    onClick: function () {
      return !(child === null || child === void 0 ? void 0 : child.disabled) && (handleSideNavItemClick === null || handleSideNavItemClick === void 0 ? void 0 : handleSideNavItemClick([item.key, child.key]));
    },
    className: classNames('flex items-center justify-between gap-1', styles.sideNavContentWrapper, (_b = {}, _b[styles.sideNavItemChildActive] = item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[0]) && child.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[1]), _b[styles.sideNavItemChildDisabled] = child === null || child === void 0 ? void 0 : child.disabled, _b))
  }, React__default.createElement(HorizonText, {
    className: styles.sideNavItemChildLabel
  }, child.label, child.isNew && React__default.createElement(SideNavItemChip, {
    text: "New",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), child.isBeta && React__default.createElement(SideNavItemChip, {
    text: "Beta",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), child.isLocked && React__default.createElement(Lock, {
    className: styles.lockIcon
  })));
};
var SideNavItemContentV2 = function (_a) {
  var _b;
  var _c, _d;
  var item = _a.item,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    activeKey = _a.activeKey;
  _a.collapsed;
  return React__default.createElement("div", {
    className: classNames(styles.sideNavItemContent, styles.v2, (_b = {}, _b[styles.sideNavItemContentWithoutChildren] = !((_c = item === null || item === void 0 ? void 0 : item.childrenProps) === null || _c === void 0 ? void 0 : _c.length), _b))
  }, (_d = item.childrenProps) === null || _d === void 0 ? void 0 : _d.map(function (child) {
    return getActiveAppPath(child) ? React__default.createElement(CustomLink, {
      key: child.key,
      to: getActiveAppPath(child)
    }, React__default.createElement(NavItemTextV2, {
      item: item,
      child: child,
      handleSideNavItemClick: handleSideNavItemClick,
      activeKey: activeKey
    })) : React__default.createElement(NavItemTextV2, {
      key: child.key,
      item: item,
      child: child,
      handleSideNavItemClick: handleSideNavItemClick,
      activeKey: activeKey
    });
  }));
};
var NavItemTextV2 = function (_a) {
  var _b;
  var item = _a.item,
    child = _a.child,
    handleSideNavItemClick = _a.handleSideNavItemClick,
    activeKey = _a.activeKey;
  return React__default.createElement("div", {
    "data-state": "".concat(item.key, "-").concat(child.key),
    onClick: function () {
      return !(child === null || child === void 0 ? void 0 : child.disabled) && (handleSideNavItemClick === null || handleSideNavItemClick === void 0 ? void 0 : handleSideNavItemClick([item.key, child.key]));
    },
    className: classNames('flex items-center justify-between gap-1', styles.sideNavContentWrapper, (_b = {}, _b[styles.sideNavItemChildActive] = item.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[1]) && child.key === (activeKey === null || activeKey === void 0 ? void 0 : activeKey[2]), _b[styles.sideNavItemChildDisabled] = child === null || child === void 0 ? void 0 : child.disabled, _b))
  }, React__default.createElement(HorizonText, {
    className: styles.sideNavItemChildLabel
  }, child.label, child.isNew && React__default.createElement(SideNavItemChip, {
    text: "New",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), child.isBeta && React__default.createElement(SideNavItemChip, {
    text: "Beta",
    textColor: CssVariables['--up-black-0'],
    backgroundColor: CssVariables['--up-green-50']
  }), child.isLocked && React__default.createElement(Lock, {
    className: styles.lockIcon
  })));
};
var SideNavItemChip = function (_a) {
  var _b = _a.text,
    text = _b === void 0 ? '' : _b,
    _c = _a.textColor,
    textColor = _c === void 0 ? '' : _c,
    _d = _a.backgroundColor,
    backgroundColor = _d === void 0 ? '' : _d;
  return React__default.createElement(HorizonChip, {
    status: {
      text: text,
      textColor: textColor,
      backgroundColor: backgroundColor
    },
    containerProps: {
      style: {
        padding: '4px',
        marginInlineStart: 'auto'
      }
    },
    textProps: {
      style: {
        fontSize: '0.55rem',
        lineHeight: '0.375rem'
      }
    }
  });
};
export { SideNavItemChip, SideNav as default };
//# sourceMappingURL=index.js.map
